<svg width="15"
     height="8"
     viewBox="0 0 15 8"
     fill="none"
     xmlns="http://www.w3.org/2000/svg"
     aria-hidden="true"
     focusable="false">
      <path d="M13.5 1L8.20711 6.29289C7.81658 6.68342 7.18342 6.68342 6.79289 6.29289L1.5 1"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round" />
</svg>